import React, {useCallback, useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router';
import {useTranslation} from 'react-i18next';
import {Location} from 'history';
import client from 'lib/CommonApi/client';
import {callAlertWeb, callNativeWeb, footerShowEventWeb} from 'common/appInterface';
import {AxiosError} from "axios";
import Modal from '../../components/Modal';
import StringUtils from "common/stringUtils";
import CardInfo from "views/CardManage/CardInfo";
import { useLoading } from 'components/Loading/LoadingProvider';

const CardMonthlyFeeTypeView: React.FC = () => {
    /** Location State */
    const location = useLocation() as Location<LocationState>;
    /** Navigate */
    const navigate = useNavigate();
    /** 다국어처리 */
    const { t, i18n } = useTranslation();

  const { showLoading, hideLoading } = useLoading();

    const screenId = 'SERV17';
    const screenName = t('SERV17.title');

    const cardInfo = location.state.info;
    const [onLoad, setOnLoad] = useState<boolean>(false);
    const [monthlyFeeTypeList, setMonthlyFeeTypeList] = useState<Array<CardMonthlyTypeInfo>>([]);
    const [monthlyFeeType, setMonthlyFeeType] = useState<string>('01');
    const [nextChargeMonth, setNextChargeMonth] = useState<string>('');


    const [isModal, setIsModal] = useState<boolean>(false);

    const inquiryMonthlyFeeType = useCallback(async () => {
      showLoading();
      console.log('cardApply', location.state.apply);

      await client
        .get('/api/app/apply/inquiryMonthlyFeeType', {
          params: {
            ...location.state.query,
            cardProductCode:
              location.state.apply.callPage === 'cardApply'
                ? location.state.apply.cardApply.cardProductCode
                : cardInfo.cardProductCode,
            alternativeCardNo:
              location.state.apply.callPage === 'cardApply'
                ? ''
                : cardInfo.alternativeCardNo,
            cardMemberNo:
              location.state.apply.callPage === 'cardApply'
                ? ''
                : cardInfo.cardMemberNo
          }
        })
        .then((response) => {
          if (response.data.code === '00') {
            setMonthlyFeeTypeList(response.data.response);

            if (
              response.data.response.length > 0 &&
              response.data.response[0].monthlyFeePayTypeCode !== ''
            ) {
              setMonthlyFeeType(
                StringUtils.checkValueNull(
                  response.data.response[0].monthlyFeePayTypeCode
                )
                  ? '01'
                  : response.data.response[0].monthlyFeePayTypeCode
              );
              setNextChargeMonth(response.data.response[0].nextChargeMonth);
            }
          }
        })
        .catch((e: AxiosError) => {
          callAlertWeb('ERROR', '99', e.message);
        })
        .finally(() => {
          hideLoading();
        });
    }, [location, cardInfo, showLoading, hideLoading]);

    const onClickMonthlyFeeType = (typeCode:string) => {
        setMonthlyFeeType(typeCode);
    };

    const changeMonthlyFeeTypeAPI = useCallback(async () => {
      showLoading();

      await client
        .post('/api/app/apply/changeMonthlyFeeType', {
          ...location.state.query,
          cardProductCode:
            location.state.apply.callPage === 'cardApply'
              ? location.state.apply.cardApply.cardProductCode
              : cardInfo.cardProductCode,
          alternativeCardNo:
            location.state.apply.callPage === 'cardApply'
              ? ''
              : cardInfo.alternativeCardNo,
          cardMemberNo:
            location.state.apply.callPage === 'cardApply'
              ? ''
              : cardInfo.cardMemberNo,
          monthlyFeePayTypeCode: monthlyFeeType,
          processStep:
            location.state.apply.callPage === 'cardApply'
              ? 'cardIssue'
              : 'monthlyFeeTypeChange',
          receiveSeq:
            location.state.apply.callPage === 'cardApply'
              ? location.state.apply.cardApply.receiveSeq
              : '',
          receiveDate:
            location.state.apply.callPage === 'cardApply'
              ? location.state.apply.cardApply.receiveDate
              : ''
        })
        .then((response) => {
          console.log('changeMonthlyFeeType response', response);
          if (response.data.code === '00') {
            if (location.state.apply.callPage === 'cardApply') {
              // 카드발급신청은 완료로 이동
              navigate('/apply/complet', {
                state: {
                  ...location.state,
                  apply: location.state.apply.cardApply
                }
              });
            } else {
              callAlertWeb(
                'SUCCESS',
                response.data.code,
                response.data.message
              );

              navigate('/main', {
                state: {
                  query: location.state.query,
                  swiperIndex: location.state.swiperIndex,
                  tabIndex: location.state.tabIndex,
                  from: location.pathname
                }
              });
            }
          } else if (response.data.code === '98') {
            setIsModal(true);
          }
        })
        .catch((e: AxiosError) => {
          callAlertWeb('ERROR', '99', e.message);
        })
        .finally(() => {
          hideLoading();
        });
    }, [
      location,
      cardInfo,
      monthlyFeeType,
      navigate,
      showLoading,
      hideLoading
    ]);

    const closeModal = useCallback(
        () => {
            navigate("/main", {
                state: {
                    query: location.state.query
                    ,swiperIndex: location.state.swiperIndex
                    ,tabIndex: location.state.tabIndex
                    ,from: location.pathname
                    ,linkOpenMenu : 'monthlyFeeHistory'
                }});
        },
        [navigate, location],
    );

    /** 뒤로가기 처리 (backKeyEvent_App (APP > WEB)) */
    const callbackBackkeyEvent = useCallback(() => {
        if (location.state.linkOpenMenu === 'main') {
            navigate("/main", {
                state: {
                    query: location.state.query
                    ,swiperIndex: location.state.swiperIndex
                    ,tabIndex: location.state.tabIndex
                    ,from: location.pathname
                }
            });
        } else {
            navigate(-1);
        }
    }, [navigate, location.state.linkOpenMenu, location.state.query, location.state.swiperIndex, location.state.tabIndex, location.pathname]);
	
	/** 신청완료 후처리 호출 */
	const callComplet = useCallback(async () => {
		await client.patch("/api/app/apply/complet", { ...location.state.query, receiveSeq: location.state.apply.cardApply.receiveSeq, receiveDate: location.state.apply.cardApply.receiveDate }).then((response) => {
			let result = response.data.response;
			console.log(result);
		}).catch((e: AxiosError) => {
			callAlertWeb("ERROR", "99", e.message);
		});
	}, [location]);

    // 최초실행
    useEffect(() => {
        // 언어설정
        i18n.changeLanguage(location.state.query.languageCode);
        // callNative_Web 처리 (WEB > APP)
        callNativeWeb(screenId, screenName, location.state.from === '/intro' ? 'Y' : 'N');
        // 하단바 숨기기
        footerShowEventWeb('N');

        console.log('QUERY STATE');
        console.log(location.state);
        console.log(cardInfo);
		
		if (location.state.apply.callPage === 'cardApply') {
			callComplet();
		}

        // 최초한번실행 useEffect() Warning 제거
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // 뒤로가기 이벤트 리스너 (backKeyEvent_App (APP > WEB))
    useEffect(() => {
        document.addEventListener('backpress', callbackBackkeyEvent);
        return () => document.removeEventListener('backpress', callbackBackkeyEvent);
    }, [callbackBackkeyEvent]);

    useEffect(() => {
        if (!onLoad) {
            // 카드 월회비 선입금
            inquiryMonthlyFeeType();
            setOnLoad(true);
        }
    },[location, inquiryMonthlyFeeType, onLoad, setOnLoad]);

    return (
        <section className="pdt3 pdb70">
            <div id='wrap'>
                {
                    (location.state.apply.callPage === 'cardApply')
                        ? (<CardInfo cardProductCode={location.state.apply.cardApply.cardProductCode} />)
                        : (<CardInfo cardProductCode={cardInfo.cardProductCode}
                                     designDivisionCode={cardInfo.designDivisionCode}
                                     cardProductCodeName={cardInfo.cardProductCodeName}
                        />)
                }
                <div id='container' className='pcHidden'>
                    <section className='contents listtyp01 '>
                        <div className='inner mgt30'>
                            <section className='manage'>
                                <p className='guideText'>
                                    {t('SERV17.explan01')}
                                </p>
                                {
                                    (monthlyFeeTypeList !== null && monthlyFeeTypeList.length > 0) && (
                                        monthlyFeeTypeList.map((item:CardMonthlyTypeInfo, index:number) => (
                                            item.typeCode === '01' ? (
                                                <div key={index} className={item.typeCode === monthlyFeeType?'listbox02 on':'listbox02'} onClick={()=>onClickMonthlyFeeType(item.typeCode)}>
                                                    <div className='contBox'>
                                                        <span className={item.typeCode === monthlyFeeType?'ico ico-radio-on':'ico ico-radio-off'}></span>
                                                        <div className='innerGroup'>
                                                            <p className='boxHeader'>{item.typeTitle}</p>
                                                            <p>{item.payFee} KRW</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div key={index} className={item.typeCode === monthlyFeeType?'listbox02 on':'listbox02'} onClick={()=>onClickMonthlyFeeType(item.typeCode)}>
                                                    <div className='contBox'>
                                                        <span className={item.typeCode === monthlyFeeType?'ico ico-radio-on':'ico ico-radio-off'}></span>
                                                        <div className='innerGroup'>
                                                            <p className='boxHeader'>{item.typeTitle}</p>
                                                            <p className='txtEffect01'>{item.discountRate}% Discount (-{item.discountAmount} KRW)</p>
                                                            <p><span className='txtEffect02'>{item.totalFee} KRW</span>{item.payFee} KRW</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        ))
                                    )
                                }
                            </section>
                        </div>
                        <div className='inner bgBoxTy'>
                            <p className='tit'>{t('SERV17.header04')}</p>
                            {
                                (location.state.apply.callPage !== 'cardApply') && (
                                    <div className='txtGroup'>
                                        <p>ㆍ</p>
                                        <p>{t('SERV17.explan02')}<br/>&#40;<span className='txtEffect02'>{nextChargeMonth}</span>&#41;</p>
                                    </div>
                                )
                            }
                            <div className='txtGroup'>
                                <p>ㆍ</p>
                                <p>{t('SERV17.explan04')}</p>
                            </div>
                            <div className='txtGroup'>
                                <p>ㆍ</p>
                                <p>{t('SERV17.explan05')}</p>
                            </div>
                        </div>
                    </section>
                    <div className="btnArea">
                        <div className="btnWrapTy01">
                            <button type="button" className="btnPrimaryTy01" onClick={changeMonthlyFeeTypeAPI}><span>{t("COMMON.button.next")}</span></button>
                        </div>
                    </div>
                </div>
            </div>
            <Modal isOpen={isModal} contentLabel="modal" onRequestClose={closeModal} className="popTyLayer2" overlayClassName="dim" closeTimeoutMS={500}>
                <p className="message">{t("SERV17.modal.content")}</p>
                <div className="btnWrapTy02">
                    <button type="button" className="btnPrimaryTy03" onClick={() => closeModal()}><span>{t("SERV17.modal.button")}</span></button>
                </div>
            </Modal>
        </section>
    );
};

export default CardMonthlyFeeTypeView;